import {combineReducers} from 'redux';
import {authentication} from './authentication.reducer';
import {users} from './users.reducer';
import {alert} from './alert.reducer';
import {ventas} from './ventas.reducer';
import {producto} from './producto.reducer';
import {busqueda} from './busqueda.reducer';

const rootReducer = combineReducers({
    authentication,
    users,
    alert,
    ventas,
    producto,
    busqueda
});

export default rootReducer;
